import React, { Component, createRef, cloneElement } from 'react';
import { Checkbox, Tooltip } from '@platform/base';
import classnames from 'classnames';
import ResizeObserver from 'rc-resize-observer';
import { FixedSizeList as List } from 'react-window';
import Hyperlink from '../../components/hyperlink';
import { findDOMNode } from 'react-dom';

let COLUMN_OPR_KEY = [ 'opr', 'operate'];

export default class LargeCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bodyWidth: 0,
            bodyHeight: 0,
            cardHeight: 0,
            layout: {},
        };
        this.cardRef = createRef(null);
    }

    render() {
        let { store, cardColCount=1 } = this.props, //cardColCount 几个卡片一行，默认是1个卡片占据一行
            locale = store.getLocale(),
            { bodyWidth, bodyHeight, cardHeight, layout } = this.state;

        let visibleRows = store.getVisibleRows();
        let rowIndexs = Array.from({ length:visibleRows.length }, (_, i)=>i);
        
        return visibleRows.length ? (
            <ResizeObserver
                onResize={({ height }, target) => {
                    this.setState({
                        bodyWidth: target.offsetWidth,
                        bodyHeight: height,
                    });
                }}
            >
                <div 
                    className='grid-table-wrapper'
                >
                    <List
                        height={bodyHeight - 24}
                        itemCount={Math.ceil(visibleRows.length/cardColCount)} //渲染行数
                        itemSize={cardHeight + 8}
                        width={bodyWidth}
                        className='virtual-list grid-table-body grid-card-large'
                        outerElementType={this.outer}
                        itemKey={index => {
                            return visibleRows[index].key;
                        }}
                    >
                        {({ index, style }) => { 
                            let renderRowIndexs = rowIndexs.slice(index*cardColCount, index*cardColCount+cardColCount);
                            return <div 
                                key={visibleRows[index].key} 
                                style={{
                                    ...style,
                                    paddingBottom: 8,
                                }}
                                className='virtual-card-wrapper'
                            >
                                <ResizeObserver
                                    onResize={({ height }) => {
                                        if (height !== this.state.cardHeight) {
                                            // eslint-disable-next-line react/no-direct-mutation-state
                                            this.state.cardHeight = height;
                                            this.setState({ cardHeight: height });
                                        }
                                    }}
                                >
                                    {
                                        renderRowIndexs.map(rowIndex=>{
                                            return <Card 
                                                key = {rowIndex}
                                                {...this.props} 
                                                row={visibleRows[rowIndex]}
                                                layout={layout}
                                                onResize={layout => {
                                                    if (Object.entries(layout).some(([key, value]) => this.state.layout[key] !== value)) {
                                                        this.setState({ layout }); 
                                                    }
                                                }}
                                            />;
                                        })
                                    }
                                    
                                </ResizeObserver>
                            </div>;
                        }}
                    </List>
                </div>
            </ResizeObserver>
        ) : (
            <div className="grid-table-wrapper empty-card">
                <i className='empty-table-icon'></i>
                <span className='empty-table-text'>{locale['table0033'] /*暂无数据*/}</span>
            </div>
        );
    }

    outer = props => {
        let { store } = this.props,
            locale = store.getLocale(),
            { showCheck, tableHead } = store.getConfig();

        let checkedKeys = store.getCheckedKeys(),
            disabledKeys = store.getDisabledKeys(),
            rows = store.getVisibleRows(),
            checked = checkedKeys.size > 0 && rows.every(row => disabledKeys.has(row.key) || checkedKeys.has(row.key)),
            indeterminate = !checked && checkedKeys.size > 0 && rows.some(row => disabledKeys.has(row.key) || checkedKeys.has(row.key));

        let { children, ...others } = props;
        return <div {...others}>
            {showCheck && <div className='grid-table-header'>
                <div className='card-select-wrapper'>
                    <Checkbox
                        disabled={rows.length && rows.every(row => disabledKeys.has(row.key))}
                        checked={checked}
                        indeterminate={indeterminate}
                        onChange={value => {
                            if(value){
                                store.checkAll();
                            } else {
                                store.setCheckedKeys(new Set());
                            }
                            this.props.checkboxConfig?.onCheck?.('', { checkedKeys: store.getCheckedKeys() });
                        }}
                    /> {locale['table0036'] /** 全选 */}
                </div>
                {typeof tableHead === 'function' && <div className='card-customer-wrapper'>{tableHead()}</div>}
            </div>}
            {cloneElement(children, { className: 'scroll-container' })}
        </div>;
    }
}

class Card extends Component {
    constructor(props) {
        super(props);
        this.state = { ...props.layout };
    }

    render() {
        return this.renderCard();
    }

    renderCard = () => {
        let { row, store, rowProps, onResize, setCardClass, cardColCount=1 } = this.props,
            { cardWidth, cardSpace, calcColumnCount } = this.state,
            { fieldConfig, imgSize, showCheck, columnCount, checkboxShow } = store.getConfig(),
            { title, subTitle, status, statusPosition, buttonPosition, img } = fieldConfig;

        let columns = store.getVisibleColumns(),
            checkedKeys = store.getCheckedKeys(),
            disabledKeys = store.getDisabledKeys(),
            titleCol,
            subTitleCol,
            statusColumns = [],
            contentColumns = [],
            buttonColKey;

        let fontSizeBaseCol = title || subTitle,
            titleFontStyle = { fontSize: Math.max(fontSizeBaseCol?.labelSize ?? 0, fontSizeBaseCol?.valueSize ?? 0, 14) };

        let noLableShow = true;
        let rawRowProps = rowProps(row);

        columns.forEach(column => {
            if (column.key === title) {
                titleCol = column;
            } else if (column.key === subTitle) {
                subTitleCol = column;
            } else if (COLUMN_OPR_KEY.includes(column.key) && column.render && column.itemtype === 'customer') {
                buttonColKey = column.key;
            } else if (status?.includes(column.key)) {
                statusColumns.push(column);
            } else {
                if(column.showLabel) {noLableShow = false;}
                contentColumns.push(column);
            }
        });
        if(!title && !subTitle){
            // 无标题时，状态在右边
            statusColumns.length && (fieldConfig.statusPosition = 'inner');
        } else if(buttonPosition !== 'top') {
            // 有标题区域时，按钮仅支持右上角 无标题区域时可以上中下
            fieldConfig.buttonPosition = 'top';
        }
        let customCardClass = {};
        if(typeof setCardClass === "function") {
            customCardClass= setCardClass(row);
        }
        return <div
            className={classnames(
                'large-card-wrapper',
                `card-${imgSize}`,
                { 'card-disabled' : disabledKeys.has(row.key) },
                { 'card-checkbox-hover': checkboxShow === 'hover' },
                customCardClass,
            )}
            style = {{ width:`${100/cardColCount}%` }}
            onClick={e => {
                rawRowProps?.onClick?.(e);
            }}
            onDoubleClick={e => {
                rawRowProps?.onDoubleClick?.(e);
            }}
            rowKey={row.key}
            onMouseOut={() => {
                this.setState({ currentTip: '' });
            }} 
        >
            {/* 内容区域 */}
            <div
                className={classnames(
                    'card-content-wrapper',
                    { 'border-bottom': !!buttonColKey },
                )}>
                {showCheck && <div
                    style={titleFontStyle}
                    className={classnames(
                        'card-checkbox-wrapper',
                        'show-left',
                        { 'show-hover': checkboxShow === 'hover' },
                        { 'card-with-img': img && imgSize },
                    )}
                >
                    {/* 复选框 */}
                    <Checkbox
                        className={classnames('card-checkbox')}
                        disabled={disabledKeys.has(row.key)}
                        checked={checkedKeys.has(row.key)}
                        onChange={value => {
                            let checkedKey = row.key,
                                lastCheckedKeys = new Set([...checkedKeys]);
                            if (value) {
                                checkedKeys.add(checkedKey);
                            } else {
                                checkedKeys.delete(checkedKey);
                            }
                            store.setCheckedKeys(checkedKeys);
                            this.props.checkboxConfig?.onCheck?.(row.key, { isChecked: value, checkedKeys, lastCheckedKeys });
                        }}
                        tabIndex="-1"
                        onClick={e => e.stopPropagation()}
                    />
                </div>}
                {/* 图片 */}
                {imgSize && img && <div className='card-img-wrapper'>
                    {typeof img === 'string' && <i className={`iconfont ${img} `} />}
                    {typeof img === 'function' && img(row, row.dataIndex)}
                </div>}
                <ResizeObserver
                    onResize={offset => {
                        let cardSpace, calcParentPureWidth, calcColumnCount;
                        let { width } = offset,
                            containerWidth = width - 8; // padding-left

                        if(columnCount){
                            calcColumnCount = columnCount;
                            if(calcColumnCount > 3) {
                                cardSpace = 12;
                            } else {
                                cardSpace = 8;
                            }
                            calcParentPureWidth = containerWidth - (calcColumnCount - 1) * cardSpace;
                        } else {
                            let baseColumnCount = [6, 5, 4, 3, 2, 1];
                            if(noLableShow){ // 无标题 + 1列
                                noLableShow && (baseColumnCount = baseColumnCount.map(e => e + 1));
                            }

                            if(containerWidth >= 1710){
                                // 1710 有字段6列，无字段7列，间距12
                                calcColumnCount = baseColumnCount[0];
                                cardSpace = 12;
                            } else if(containerWidth >= 1230){
                                // 1230 有字段5列，无字段6列，间距12
                                calcColumnCount = baseColumnCount[1];
                                cardSpace = 12;
                            } else if(containerWidth >= 930){
                                // 930 有字段4列，无字段5列，间距12
                                calcColumnCount = baseColumnCount[2];
                                cardSpace = 12;
                            } else if(containerWidth >= 710){
                                // 710 有字段3列，无字段4列，间距12
                                calcColumnCount = baseColumnCount[3];
                                cardSpace = 8;
                            } else if(containerWidth >= 490){
                                // 490 有字段2列，无字段3列，间距12
                                calcColumnCount = baseColumnCount[4];
                                cardSpace = 8;
                            } else {
                                // 270 有字段1列，无字段2列，间距12
                                calcColumnCount = baseColumnCount[5];
                                cardSpace = 8;
                            }

                            calcParentPureWidth = containerWidth - (calcColumnCount - 1) * cardSpace;
                        }
                        let layout = { cardWidth: calcParentPureWidth / calcColumnCount, cardSpace, calcColumnCount };
                        onResize(layout);
                        this.setState(layout);
                    }}
                >
                    <div className='card-column-wrapper'>
                        {/* 标题,存在没标题的情况 */}
                        {(titleCol || subTitleCol) && <div className='card-title-status-wrapper'>
                            <div className='card-title-wrapper'>
                                {/* 主标题 */}
                                {this.renderField(row, titleCol, { className: 'card-title' }, store)}
                                {/* 副标题 */}
                                {this.renderField(row, subTitleCol, { className: 'card-sub-title' }, store)}
                                {/* 状态-右 */}
                                {statusPosition === 'right' && statusColumns.length > 0 && this.renderStatusField(row, statusColumns)}
                            </div>
                            {buttonColKey && buttonPosition === 'top' && this.renderOpr(row, buttonColKey)}
                        </div>}
                        {/* 状态-下 */}
                        {statusPosition === 'bottom' && statusColumns.length > 0 && this.renderStatusField(row, statusColumns)}
                        {/* 内容 */}
                        <div className='card-normal-column-wrapper'>
                            {contentColumns.map((column, index) => this.renderField(
                                row,
                                column,
                                { style: { width: cardWidth, marginRight: (index + 1) % calcColumnCount ? cardSpace : 0 } },
                                store,
                            ) )}
                        </div>
                    </div>
                </ResizeObserver>
                {!title && !subTitle && statusColumns?.length > 0 && this.renderStatusField(row, statusColumns)}
                {buttonColKey && !title && !subTitle && this.renderOpr(row, buttonColKey)}
            </div>
        </div>;
    }

    renderField = (row, column, props = {}, store) => {
        if (!column) {return null;}

        let {
                label,
                showLabel,
                key: colKey,
                itemtype,
            } = column,
            { labelStyle } = this.getStyle(column),
            { hidden } = store.getCellProps(row.key, column.attrcode||column.key);
        return !hidden && <div className={`card-col card-${itemtype}-${colKey} ${props.className ?? ''}`} style={props.style ?? {}}>
            {showLabel && <span className='card-col-label' style={labelStyle}>
                {label}:
            </span>}
            <span
                className='card-col-display'
                onMouseEnter={() => {
                    this.setState({ currentTip: '' });
                    let cellDom = findDOMNode(this).querySelector(`.large-card-wrapper[rowkey="${row.key}"] .card-${itemtype}-${colKey} .tooltip-content`);
                    if (cellDom) {
                        if (cellDom.scrollWidth > cellDom.clientWidth) {
                            this.setState({ currentTip: `${row.key}-${column.key}` });
                        } 
                    }
                }}
                onMouseOut={() => {
                    this.setState({ currentTip: '' });
                }} 
            >
                {this.renderColDisplay(row, column)}
            </span>
        </div>;
    }

    renderColDisplay = (row, column) => {
        let { store, id } = this.props,
            { contentStyle } = this.getStyle(column),
            searchKeyWord = store.getKeyWord(),
            {
                key: colKey,
                itemtype,
                hyperlinkflag: hyperLinkFlag,
                hyperlinktype: hyperLinkType,
                hyperlinkname: hyperLinkName,
                hyperlinkurl: hyperLinkUrl,
                datatype,
                render,
            } = column;
        if(hyperLinkFlag){
            return <Hyperlink
                name={hyperLinkName}
                url={hyperLinkUrl}
                type={hyperLinkType}
                cellValue={store.getCellValue(row.key, colKey)}
                searchKeyWord={searchKeyWord}
                itemType={itemtype}
                meta={store.getMeta()}
                tableId={id}
                colKey={colKey}
                locale={store.getLocale()}
                datatype={datatype}
                className={classnames(
                    'cell-hyper',
                    'code-detail-link',
                    { 'hyper-link-out': hyperLinkType === '2' && hyperLinkUrl && itemtype !== 'refer' },
                )}
            />;
        } else if(typeof render === 'function'){
            return render(store.getCellValue(row.key, colKey), row, row.dataIndex);
        } else {
            let content = row.values[column.key]._display_;
            if(searchKeyWord && content.includes(searchKeyWord)){
                let contentTmp = content.split(searchKeyWord);
                content = [];
                contentTmp.forEach((e, index) => {
                    content.push(e);
                    index !== contentTmp.length - 1 && content.push(<span key={index} className="high-light">{searchKeyWord}</span>);
                });
            }
            return this.renderTooltip(
                content,
                <div className='card-col-display-tooltip'>
                    <div className='tooltip-content' style={contentStyle}>{content}</div>
                </div>,
                row,
                column,
            );
        }
    }

    renderTooltip = (overlay = '', content, row, column) => {
        let { itemtype, key: colKey } = column,
            { currentTip } = this.state;

        if (currentTip === `${row.key}-${colKey}` && itemtype !== 'attachment') {
            return <Tooltip
                placement="rightBottom"
                overlay={overlay}
                mouseEnterDelay={1}
                inverse
                visible
            >
                { content }
            </Tooltip>;
        }

        return content;
    }

    renderStatusField = (row, statusColumns) => {
        let { store } = this.props,
            { fieldConfig } = store.getConfig(),
            { statusStyle, statusPosition } = fieldConfig;

        return <div className={`card-status-wrapper status-${statusPosition}`}>
            {statusColumns.map((column, index) => {
                let { key, render } = column;
                return <div
                    key={key}
                    className={`status-${key} card-status`}
                    style={{ background: statusStyle[index][row.values[key].value] }}
                >
                    {render?.(row.values[key], row, row.dataIndex, store) || row.values[key]._display_}
                </div>;
            })
            }
        </div>;
    }

    renderOpr = (row, buttonColKey) => {
        let { store } = this.props,
            { fieldConfig } = store.getConfig(),
            { buttonPosition } = fieldConfig;
        return <div className={`card-button-wrapper button-position-${buttonPosition}`}>
            {store.getColumnProps(buttonColKey).render('', row, row.dataIndex)}
        </div>;
    }

    getStyle = column => {
        return {
            labelStyle: {
                background: column.background,
                color: column.color,
                fontSize: column.fontSize,
                fontWeight: column.fontWeight,
            },
            contentStyle: {
                background: column.contentBackground,
                color: column.contentColor,
                fontSize: column.contentFontSize,
                fontWeight: column.contentFontWeight,
            },
        };
    }
}